/* 🤖 this file was generated by svg-to-ts */
export const sbIconsCreditCard: {
  name: 'credit-card';
  data: string;
} = {
  name: 'credit-card',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="M5 12.5h3a.99997.99997 0 0 0 .70711-1.7071A1.0002 1.0002 0 0 0 8 10.5H5a.99997.99997 0 0 0-.70711 1.7071c.18754.1875.44189.2929.70711.2929m12-10H3a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3.0001 3.0001 0 0 0 3-3v-9a3.00006 3.00006 0 0 0-3-3m1 12c0 .2652-.1054.5196-.2929.7071A1 1 0 0 1 17 15.5H3a.99997.99997 0 0 1-1-1v-6h16zm0-8H2v-1a1.00003 1.00003 0 0 1 1-1h14a.99997.99997 0 0 1 1 1z"/></svg>`
};
